import useFeatureFlag from 'app/hooks/useFeatureFlag';
import { FEATURE_FLAGS } from 'app/services/featureFlag.service';

function useFeatureFlagRoutes() {
  const { value: showActivitiesBatchManagement } = useFeatureFlag(FEATURE_FLAGS.SHOW_ACTIVITIES_BATCH_MANAGEMENT);
  const { value: showLemonadeAiFeedback } = useFeatureFlag(FEATURE_FLAGS.SHOW_LEMONADE_FEEDBACK_GENERATOR);
  const { value: showMessagesGlobal } = useFeatureFlag(FEATURE_FLAGS.SHOW_MESSAGES_GLOBAL);
  const { value: showLicenseMonoProgram } = useFeatureFlag('showLicenseMonoProgram');

  return {
    showLicenseMonoProgram,
    showActivitiesBatchManagement,
    showMessagesGlobal,
    showLemonadeAiFeedback,
  };
}

export default useFeatureFlagRoutes;
